/** Trang của màn hàng đợi đồng bộ, được giữ trên URL search param. */
export interface ExpenseSyncSearch {
    page?: number
}

/**
 * Chuẩn hoá search param thô của màn hàng đợi đồng bộ.
 *
 * Màn này không có bộ lọc — hàng đợi vốn đã hẹp (chỉ giao dịch tiền ra chưa
 * duyệt) nên chỉ cần giữ số trang. `page` chỉ giữ lại khi > 1 để URL ở trang
 * đầu luôn sạch.
 */
export function normalizeExpenseSyncSearch(
    search: Record<string, unknown>,
): ExpenseSyncSearch {
    const out: ExpenseSyncSearch = {}

    // Đến từ URL nên page thường là chuỗi ('?page=3'), không phải number.
    const page =
        typeof search.page === 'number' ? search.page : Number(search.page)
    if (Number.isFinite(page) && page > 1) {
        out.page = Math.floor(page)
    }

    return out
}
